export function generate() {
  const snippet = () => {
    return Math.trunc((Math.random() + 1) * 2 ** 16)
      .toString(16)
      .substring(1)
  }
  return `N${Date.now()}U${snippet()}G${snippet()}L`
}
